import {createAsyncThunk} from '@reduxjs/toolkit'
import {productRulesApi} from './productRulesApi'

// Product Groups
export const fetchProductGroups = createAsyncThunk(
  'productRules/fetchProductGroups',
  async ({client}, {rejectWithValue}) => {
    try {
      return await productRulesApi.getProductGroups(client)
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  },
)
